export default __webpack_public_path__ + "static/media/cover1.6cd3d491.jpg";